import fp from 'lodash/fp';
import { unfixedFloor } from '../../utils';
import percentageChart from './percentage-chart';

// Width of a progress wheel "column" 
const wheelWidth = 120

/*
 * Shifts the PDF "cursor" left/right the number of "wheelWidth"s passed.
 * 
 * Here we return this as a one element array, which contains one element which is an array of two elements, 
 * which is the translate instruction. Hence the [[blah]] style. This means it can be inserted into a sequence
 * of instructions with a '...translateWheelOffset(x)' style.
 * 
 * Note, we could have just returned '[blah]' and then have users insert this into their arrays directly,
 * (i.e. like 'translateWheelOffset(x)' without the dots) but most functions like this in the codebase return 
 * multiple instructions, so I think it's more consistant to follow this pattern. It also allows this list of
 * instructions it returns to be extended, if it needs to for some bizarre reason, without changing the code 
 * of all the callers.
 */
export const translateWheelOffset = steps => 
  [[
    'translate', 
    fp.values({
      x: wheelWidth * steps,
      y: 0
    })
  ]]

export const shiftAndUnshift = list => [...translateWheelOffset(1), ...list, ...translateWheelOffset(-1)] 

export const progressGoalCharts = (goals) =>
  [
    ...fp.flatMap(
      ({ goal, completed, total }, index) => {
        const progressPercentage = unfixedFloor(100 * (completed / total), 1)
        return [
          ...percentageChart(progressPercentage),
          ['fontSize', [12]],
          ['font', ['Helvetica']],
          ['fillColour', ['#666666']],
          ['text', [`${goal.name}`, -50, -60, {
            width: 100,
            align: 'center'
          }]],
          // Each time we draw a progress wheel, translate right one step
          ...translateWheelOffset(1)
        ]
      })(goals),
    // Then translate left back to where we started, once for each goal we processed. 
    ...translateWheelOffset(-goals.length)
  ]



// WEBPACK FOOTER //
// ./src/reports/partials/progress-goal-charts.js